import type { ProjectRecord } from "@/lib/api";
import { Box, Text } from "@okshaun/components";
import { LIST_GRID, ProjectRow } from "./project-row";

interface ProjectListProps {
  projects: ProjectRecord[];
  total: number;
  selected: string | null;
  onSelect: (slug: string) => void;
}

function Head({ children }: { children: string }) {
  return (
    <Text textStyle="mono.xs" color="text.subtlest">
      {children}
    </Text>
  );
}

export function ProjectList({ projects, total, selected, onSelect }: ProjectListProps) {
  return (
    <Box as="section" display="flex" flexDir="column" gap="8" minW="0">
      <Box display="flex" alignItems="baseline" gap="16" px="12">
        <Text
          textStyle="mono.xs"
          color="text.subtlest"
          letterSpacing="widest"
          textTransform="uppercase"
        >
          Projects
        </Text>
        <Text textStyle="mono.xs" color="text.subtlest">
          {projects.length === total ? `${total} active` : `${projects.length} of ${total} active`}
        </Text>
      </Box>
      <Box display="grid" gridTemplateColumns={LIST_GRID} gap="10" px="12" py="6">
        <Head>domain</Head>
        <Head>project · by updated</Head>
        <Head>open</Head>
        <Head>waiting</Head>
        <Head>next</Head>
        <Head>upd</Head>
      </Box>
      <Box bg="surface" border="default" borderRadius="8" overflow="hidden">
        {projects.length === 0 && (
          <Text textStyle="mono.sm" color="text.subtlest" p="12">
            Nothing matches these filters.
          </Text>
        )}
        {projects.map((p) => (
          <ProjectRow
            key={p.slug}
            project={p}
            selected={selected === p.slug}
            onSelect={(slug) => onSelect(slug)}
          />
        ))}
      </Box>
      <Text textStyle="body.sm" color="text.subtlest" px="12" pt="4">
        Personal rows show what you last did and one thing you could do next. They never show
        counts. Waiting means not your move.
      </Text>
    </Box>
  );
}
